import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      // Client errors (4xx) won't fix themselves on retry; network blips might.
      retry: (failureCount, error) =>
        failureCount < 2 && !(isApiError(error) && error.status >= 400 && error.status < 500),
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});
